module.exports = __webpack_public_path__ + "img/three3Green.54971aa4.png";